import { Routes } from '@angular/router';

import { itFinancialSegments } from '@advania-cosoftware/wolf-router';

export const itFinancialRoutes: Routes = [
    {
        path: itFinancialSegments.itFinancials,
        loadComponent: () =>
            import('./pages/it-financials-tab/it-financials-tab.page').then((m) => m.ItFinancialsTabPage),
        children: [
            {
                path: itFinancialSegments.invoices,
                loadComponent: () =>
                    import('./pages/invoices/customer-invoices/customer-invoices.page').then(
                        (m) => m.CustomerInvoicesPage,
                    ),
            },
            {
                path: itFinancialSegments.costCenters,
                loadComponent: () =>
                    import('./pages/cost-centers/customer-cost-centers/customer-cost-centers.page').then(
                        (m) => m.CustomerCostCentersPage,
                    ),
            },
            {
                path: `${itFinancialSegments.costCenters}/:costCenterId`,
                loadComponent: () =>
                    import('./pages/cost-centers/customer-cost-center/customer-cost-center.page').then(
                        (m) => m.CustomerCostCenterPage,
                    ),
            },
        ],
    },
];
